import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function Level12Illustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3828">
      <div className="relative w-full h-full bg-gradient-to-br from-amber-200 via-yellow-300 to-orange-400 overflow-hidden" data-id="element-3829">
        {/* Background: Graduation glow */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3830">
          <circle cx="100" cy="95" r="78" fill="#FEF3C7" opacity="0.45" data-id="element-3831" />
          <g style={{
          transformOrigin: '100px 100px'
        }} data-id="element-3832">
            {[...Array(12)].map((_, i) => <path key={i} d="M100 100 L96 6 L104 6 Z" fill="#FFFFFF" opacity="0.18" transform={`rotate(${i * 30} 100 100)`} data-id="element-3833" />)}
          </g>
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[8%]" data-id="element-3834">
          <div className="w-[64%] h-[64%] flex items-center justify-center" data-id="element-3835">
            <DjaySpecimen look={{
            variant
          }} size="hero" emotion={isUnlocked ? 'proud' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3836" />
          </div>
        </div>

        {/* Foreground: graduation cap + level badge */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3837">
            <g transform="translate(100, 36)" data-id="element-3838">
              <path d="M-28 0 L0 -12 L28 0 L0 12 Z" fill="#1E293B" data-id="element-3839" />
              <path d="M0 12 L0 22" stroke="#1E293B" strokeWidth="2" data-id="element-3840" />
              <circle cx="0" cy="24" r="3" fill="#FBBF24" data-id="element-3841" />
            </g>
            <circle cx="40" cy="40" r="18" fill="#B45309" data-id="element-3842" />
            <text x="40" y="46" textAnchor="middle" fontFamily="sans-serif" fontSize="14" fontWeight="900" fill="white" data-id="element-3843">
              12
            </text>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}